import { onReady } from '../base/init.js';

// Комплектации: вкладки моделей показывают группу карточек выбранной модели.
onReady(() => {
  const section = document.querySelector('.complectations');
  if (!section) return;

  const buttons = section.querySelectorAll('.js-complectations-filter');
  const groups = section.querySelectorAll('.js-complectations-group');
  if (!buttons.length || !groups.length) return;

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const filter = btn.getAttribute('data-filter');
      buttons.forEach((b) => b.classList.toggle('active', b === btn));
      groups.forEach((g) => {
        g.classList.toggle('hidden', g.getAttribute('data-model') !== filter);
      });
    });
  });
});
